import { Navigate } from "react-router";
import { GateLoadingScreen } from "@/components/LoadingSkeleton";
import { useAuth } from "@/lib/shared/auth";
import { useIsAdmin } from "@/lib/shared/useIsAdmin";

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, loading: adminLoading } = useIsAdmin();

  if (authLoading || adminLoading) {
    return <GateLoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
